// extracted by mini-css-extract-plugin
module.exports = {"select-primary":"rgba(233, 71, 98, 0.55)","select-secondary":"rgba(126, 78, 180, 0.6)","select-tertiary":"rgba(53, 171, 207, 0.54)"};